import React from 'react';
import { Link } from 'react-router-dom';

const Sitemap = () => {
  const currentYear = new Date().getFullYear();

  return (
    <div className="min-h-screen bg-gradient-to-br from-orange-50 via-white to-orange-50">
      <div className="bg-gradient-to-r from-blue-900 to-blue-800 text-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="inline-block bg-orange-500 text-white px-4 py-1 rounded-full text-sm font-semibold mb-4">
            NAVIGATION
          </div>
          <h1 className="text-4xl md:text-5xl font-bold mb-4">Sitemap</h1>
          <div className="w-24 h-1 bg-orange-500 mx-auto mb-6"></div>
          <p className="text-xl text-blue-100 max-w-3xl mx-auto">
            Complete guide to all pages on RDS Group of Colleges website
          </p>
        </div>
      </div>
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          <div className="bg-white rounded-2xl shadow-xl p-6 hover:shadow-2xl transition-shadow">
            <div className="flex items-center mb-4">
              <div className="w-10 h-10 bg-orange-100 rounded-lg flex items-center justify-center mr-3">
                <svg className="w-5 h-5 text-orange-500" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z" />
                </svg>
              </div>
              <h2 className="text-xl font-bold text-blue-800">Main Pages</h2>
            </div>
            <ul className="space-y-3 pl-12">
              <li>
                <Link to="/" className="text-gray-700 hover:text-orange-600 transition-colors flex items-center">
                  <span className="w-1 h-1 bg-orange-500 rounded-full mr-2"></span>
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-700 hover:text-orange-600 transition-colors flex items-center">
                  <span className="w-1 h-1 bg-orange-500 rounded-full mr-2"></span>
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/admission" className="text-gray-700 hover:text-orange-600 transition-colors flex items-center">
                  <span className="w-1 h-1 bg-orange-500 rounded-full mr-2"></span>
                  Admission
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-700 hover:text-orange-600 transition-colors flex items-center">
                  <span className="w-1 h-1 bg-orange-500 rounded-full mr-2"></span>
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>
          <div className="bg-white rounded-2xl shadow-xl p-6 hover:shadow-2xl transition-shadow">
            <div className="flex items-center mb-4">
              <div className="w-10 h-10 bg-orange-100 rounded-lg flex items-center justify-center mr-3">
                <svg className="w-5 h-5 text-orange-500" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M9 4.804A7.968 7.968 0 005.5 4c-1.255 0-2.443.29-3.5.804v10A7.969 7.969 0 015.5 14c1.669 0 3.218.51 4.5 1.385A7.962 7.962 0 0114.5 14c1.255 0 2.443.29 3.5.804v-10A7.968 7.968 0 0014.5 4c-1.255 0-2.443.29-3.5.804V12a1 1 0 11-2 0V4.804z" />
                </svg>
              </div>
              <h2 className="text-xl font-bold text-blue-800">Programs</h2>
            </div>
            <ul className="space-y-3 pl-12">
              <li>
                <Link to="/programs/bca" className="text-gray-700 hover:text-orange-600 transition-colors flex items-center">
                  <span className="w-1 h-1 bg-orange-500 rounded-full mr-2"></span>
                  BCA (Bachelor of Computer Applications)
                </Link>
              </li>
              <li>
                <Link to="/programs/bba" className="text-gray-700 hover:text-orange-600 transition-colors flex items-center">
                  <span className="w-1 h-1 bg-orange-500 rounded-full mr-2"></span>
                  BBA (Bachelor of Business Administration)
                </Link>
              </li>
              <li>
                <Link to="/programs/pharmacy" className="text-gray-700 hover:text-orange-600 transition-colors flex items-center">
                  <span className="w-1 h-1 bg-orange-500 rounded-full mr-2"></span>
                  Pharmacy (D.Pharm, B.Pharm, M.Pharm)
                </Link>
              </li>
              <li>
                <Link to="/programs/nursing" className="text-gray-700 hover:text-orange-600 transition-colors flex items-center">
                  <span className="w-1 h-1 bg-orange-500 rounded-full mr-2"></span>
                  Nursing & Paramedical
                </Link>
              </li>
              <li>
                <Link to="/programs/iti" className="text-gray-700 hover:text-orange-600 transition-colors flex items-center">
                  <span className="w-1 h-1 bg-orange-500 rounded-full mr-2"></span>
                  ITI (Electrician, Fitter, Welder, COPA)
                </Link>
              </li>
            </ul>
          </div>
          <div className="bg-white rounded-2xl shadow-xl p-6 hover:shadow-2xl transition-shadow">
            <div className="flex items-center mb-4">
              <div className="w-10 h-10 bg-orange-100 rounded-lg flex items-center justify-center mr-3">
                <svg className="w-5 h-5 text-orange-500" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M10.394 2.08a1 1 0 00-.788 0l-7 3a1 1 0 000 1.84L5.25 8.051a.999.999 0 01.356-.257l4-1.714a1 1 0 11.788 1.838L7.667 9.088l1.94.831a1 1 0 00.787 0l7-3a1 1 0 000-1.838l-7-3zM3.31 9.397L5 10.12v4.102a8.969 8.969 0 00-1.05-.174 1 1 0 01-.89-.89 11.115 11.115 0 01.25-3.762zM9.3 16.573A9.026 9.026 0 007 14.935v-3.957l1.818.78a3 3 0 002.364 0l5.508-2.361a11.026 11.026 0 01.25 3.762 1 1 0 01-.89.89 8.968 8.968 0 00-5.35 2.524 1 1 0 01-1.4 0zM6 18a1 1 0 001-1v-2.065a8.935 8.935 0 00-2-.712V17a1 1 0 001 1z" />
                </svg>
              </div>
              <h2 className="text-xl font-bold text-blue-800">Our Institutions</h2>
            </div>
            <ul className="space-y-3 pl-12">
              <li>
                <Link to="/institutions/pharmacy-college" className="text-gray-700 hover:text-orange-600 transition-colors flex items-center">
                  <span className="w-1 h-1 bg-orange-500 rounded-full mr-2"></span>
                  R D S College of Pharmacy
                </Link>
              </li>
              <li>
                <Link to="/institutions/nursing-college" className="text-gray-700 hover:text-orange-600 transition-colors flex items-center">
                  <span className="w-1 h-1 bg-orange-500 rounded-full mr-2"></span>
                  R D S Nursing and Paramedical College
                </Link>
              </li>
              <li>
                <Link to="/institutions/mahavidyalaya" className="text-gray-700 hover:text-orange-600 transition-colors flex items-center">
                  <span className="w-1 h-1 bg-orange-500 rounded-full mr-2"></span>
                  R.D.S. Mahavidyalaya
                </Link>
              </li>
              <li>
                <Link to="/institutions/sharda-iti" className="text-gray-700 hover:text-orange-600 transition-colors flex items-center">
                  <span className="w-1 h-1 bg-orange-500 rounded-full mr-2"></span>
                  Sharda Private ITI
                </Link>
              </li>
            </ul>
          </div>
          <div className="bg-white rounded-2xl shadow-xl p-6 hover:shadow-2xl transition-shadow">
            <div className="flex items-center mb-4">
              <div className="w-10 h-10 bg-orange-100 rounded-lg flex items-center justify-center mr-3">
                <svg className="w-5 h-5 text-orange-500" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M5 3a2 2 0 00-2 2v2a2 2 0 002 2h2a2 2 0 002-2V5a2 2 0 00-2-2H5zM5 11a2 2 0 00-2 2v2a2 2 0 002 2h2a2 2 0 002-2v-2a2 2 0 00-2-2H5zM11 5a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V5zM14 11a1 1 0 011 1v1h1a1 1 0 110 2h-1v1a1 1 0 11-2 0v-1h-1a1 1 0 110-2h1v-1a1 1 0 011-1z" />
                </svg>
              </div>
              <h2 className="text-xl font-bold text-blue-800">Facilities</h2>
            </div>
            <ul className="space-y-3 pl-12">
              <li className="flex items-center">
                <span className="w-1 h-1 bg-orange-500 rounded-full mr-2"></span>
                <span className="text-gray-700">Digital Smart Classrooms</span>
              </li>
              <li className="flex items-center">
                <span className="w-1 h-1 bg-orange-500 rounded-full mr-2"></span>
                <span className="text-gray-700">Digital Lab Library</span>
              </li>
              <li className="flex items-center">
                <span className="w-1 h-1 bg-orange-500 rounded-full mr-2"></span>
                <span className="text-gray-700">Well Qualified Faculty</span>
              </li>
              <li className="flex items-center">
                <span className="w-1 h-1 bg-orange-500 rounded-full mr-2"></span>
                <span className="text-gray-700">Placement Facility</span>
              </li>
              <li className="flex items-center">
                <span className="w-1 h-1 bg-orange-500 rounded-full mr-2"></span>
                <span className="text-gray-700">Scholarship Programs</span>
              </li>
            </ul>
          </div>
          <div className="bg-white rounded-2xl shadow-xl p-6 hover:shadow-2xl transition-shadow">
            <div className="flex items-center mb-4">
              <div className="w-10 h-10 bg-orange-100 rounded-lg flex items-center justify-center mr-3">
                <svg className="w-5 h-5 text-orange-500" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M4 4a2 2 0 012-2h8a2 2 0 012 2v12a1 1 0 110 2h-4a1 1 0 01-1-1v-2H8v2a1 1 0 01-1 1H4a1 1 0 110-2V4zm3 1h2v2H7V5zm2 4H7v2h2V9zm2-4h2v2h-2V5zm2 4h-2v2h2V9z" clipRule="evenodd" />
                </svg>
              </div>
              <h2 className="text-xl font-bold text-blue-800">Legal</h2>
            </div>
            <ul className="space-y-3 pl-12">
              <li>
                <Link to="/privacy-policy" className="text-gray-700 hover:text-orange-600 transition-colors flex items-center">
                  <span className="w-1 h-1 bg-orange-500 rounded-full mr-2"></span>
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms-of-use" className="text-gray-700 hover:text-orange-600 transition-colors flex items-center">
                  <span className="w-1 h-1 bg-orange-500 rounded-full mr-2"></span>
                  Terms of Use
                </Link>
              </li>
              <li>
                <Link to="/sitemap" className="text-gray-700 hover:text-orange-600 transition-colors flex items-center font-semibold text-orange-600">
                  <span className="w-1 h-1 bg-orange-500 rounded-full mr-2"></span>
                  Sitemap (Current Page)
                </Link>
              </li>
            </ul>
          </div>
          <div className="bg-white rounded-2xl shadow-xl p-6 hover:shadow-2xl transition-shadow">
            <div className="flex items-center mb-4">
              <div className="w-10 h-10 bg-orange-100 rounded-lg flex items-center justify-center mr-3">
                <svg className="w-5 h-5 text-orange-500" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                  <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                </svg>
              </div>
              <h2 className="text-xl font-bold text-blue-800">Quick Contact</h2>
            </div>
            <div className="pl-12 space-y-2 text-sm">
              <p className="text-gray-700 font-medium">📞 7275370808, 9628362187</p>
              <p className="text-gray-700 font-medium">📧 rdscollege342@gmail.com</p>
              <p className="text-gray-700">🏛️ Kusanw Bhaupur, Jaunpur, UP-222136</p>
              <p className="text-gray-700">🌐 rdsgroupofcolleges.com</p>
            </div>
          </div>
        </div>
        <div className="mt-12 bg-blue-50 rounded-xl p-6 text-center">
          <p className="text-gray-700">
            <span className="font-semibold">XML Sitemap:</span> Available at{' '}
            <a href="/sitemap.xml" className="text-orange-600 hover:underline">/sitemap.xml</a>
          </p>
          <p className="text-sm text-gray-600 mt-2">
            This sitemap is also available for search engines to crawl and index our website.
          </p>
        </div>
        <div className="text-center text-sm text-gray-500 pt-8 mt-8 border-t border-gray-200">
          <p>© {currentYear} RDS Group of Colleges. All rights reserved.</p>
        </div>
      </div>
    </div>
  );
};

export default Sitemap;